module.exports = __webpack_public_path__ + "static/media/3.b3f5d9b2.jpg";